import BackLink from '@/components/BackLink'
import Container from '@/components/Container'
import { usePage } from '@/hooks'
import React, { useEffect, useState } from 'react'
import { News } from '@/interfaces/News'
import { api } from '@/api'
import style from './styles/news_details.module.scss'
import Section from '@/components/Section'
import MoreNews from './components/MoreNews'
import HaveQuestions from '@/components/HaveQuestions'
import DetailPageHead from '@/components/DetailPageHead/index.tsx'

const NewsDetail = (): React.ReactElement => {
  const [news, setNews] = useState<News | undefined>()
  const page = usePage()
  const { object, global } = page.init_state
  const { config } = global

  useEffect(() => {
    api
      .getNews({ id: object.id })
      .then((data) => {
        setNews(data)
      })
      .catch((error) => {
        console.error(error)
      })
  }, [object.id])

  return (
    <>
      <Container>
        <BackLink href={config.news} title='К новостям' />

        <DetailPageHead
          image={news?.detail_picture}
          date={object.date_create}
          title={object.title}
          content={news?.detail_text}
        />

        {news?.cards != null && news?.cards.length > 0
          ? (
            <Section>
              <ul className={style.cards_list}>
                {news?.cards.map((card) => {
                  return (
                    <li key={card.id} className={style.cards__item}>
                      <div className={style.cards__content}>
                        {card.uf_sub_title !== null
                          ? (
                            <span className={style.cards__place}>
                              {card.uf_sub_title}
                            </span>
                            )
                          : null}
                        <span className={style.cards__team}>{card.uf_name}</span>
                        <img
                          src={card.uf_file}
                          width='415px'
                          height='415px'
                          alt={card.uf_name}
                          className={style['cards__image--mobile']}
                        />
                        <p className={style.cards__text}>
                          {card.uf_full_description}
                        </p>
                      </div>
                      <img
                        src={card.uf_file}
                        width='415px'
                        height='415px'
                        alt={card.uf_name}
                        className={style.cards__image}
                      />
                    </li>
                  )
                })}
              </ul>
            </Section>
            )
          : undefined}

        <MoreNews />
      </Container>
      <HaveQuestions />
    </>
  )
}

export default NewsDetail
